import React from 'react';
import LazyPageLoader from '../../cmp/LazyPageLoader';

const Page = React.lazy(()=>import('./PartyLinksIndex'))

function LazyShowcaseIndex(props){
  return <React.Suspense fallback={<LazyPageLoader />}>
    <Page />
  </React.Suspense>
}


export default LazyShowcaseIndex
